module.exports = "/11/0-gioi-thieu-ve-stl/index.html.d381e349b21471222160fc598695cb22.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/34001.md
 ** module id = 581
 ** module chunks = 0
 **/